import { SuccessTasksRelationsFetch } from '@hkm/components/TaskManagement/relations/domain/interfaces';

import { getListAction } from '@ac/library-utils/dist/redux-utils';

export const fetchTasksRelations = getListAction<
  undefined,
  SuccessTasksRelationsFetch,
  undefined
>('@taskManagement/dashboard/fetchAggregatedRelations');



// WEBPACK FOOTER //
// ./src/components/TaskManagement/relations/domain/actions.ts